/**
 * Typed ThunkAction
 */
export let ActionType;

(function (ActionType) {
  ActionType["UPDATE_USER_PROFILE_REQUESTED"] = "UPDATE_USER_PROFILE_REQUESTED";
  ActionType["UPDATE_USER_PROFILE_SUCCESS"] = "UPDATE_USER_PROFILE_SUCCESS";
  ActionType["UPDATE_USER_PROFILE_FAILURE"] = "UPDATE_USER_PROFILE_FAILURE";
  ActionType["USER_SIGN_OUT"] = "USER_SIGN_OUT";
  ActionType["CONNECT_WALLET_REQUESTED"] = "CONNECT_WALLET_REQUESTED";
  ActionType["CONNECT_WALLET_SUCCESS"] = "CONNECT_WALLET_SUCCESS";
  ActionType["CONNECT_WALLET_FAILURE"] = "CONNECT_WALLET_FAILURE";
  ActionType["CREATE_ACCOUNT_REQUESTED"] = "CREATE_ACCOUNT_REQUESTED";
  ActionType["CREATE_ACCOUNT_SUCCESS"] = "CREATE_ACCOUNT_SUCCESS";
  ActionType["CREATE_ACCOUNT_FAILURE"] = "CREATE_ACCOUNT_FAILURE";
  ActionType["AUTHENTICATE_USER_REQUESTED"] = "AUTHENTICATE_USER_REQUESTED";
  ActionType["AUTHENTICATE_USER_SUCCESS"] = "AUTHENTICATE_USER_SUCESS";
  ActionType["AUTHENTICATE_USER_FAILURE"] = "AUTHENTICATE_USER_FAILURE";
  ActionType["SEND_CODE_TO_EMAIL_REQUESTED"] = "SEND_CODE_TO_EMAIL_REQUESTED";
  ActionType["SEND_CODE_TO_EMAIL_SUCCESS"] = "SEND_CODE_TO_EMAIL_SUCCESS";
  ActionType["SEND_CODE_TO_EMAIL_FAILURE"] = "SEND_CODE_TO_EMAIL_FAILURE";
  ActionType["LINK_WALLET_CLEAR_ERROR"] = "LINK_WALLET_RESET_ERROR";
  ActionType["LINK_WALLET_REQUESTED"] = "LINK_WALLET_REQUESTED";
  ActionType["LINK_WALLET_SUCCESS"] = "LINK_WALLET_SUCCESS";
  ActionType["LINK_WALLET_FAILURE"] = "LINK_WALLET_FAILURE";
  ActionType["UPDATE_WALLET_WBNB_BALANCE"] = "UPDATE_WALLET_WBNB_BALANCE";
  ActionType["UPDATE_WALLET_THC_BALANCE"] = "UPDATE_WALLET_THC_BALANCE";
  ActionType["UPDATE_WALLET_BUSD_BALANCE"] = "UPDATE_WALLET_BUSD_BALANCE";
  ActionType["UPDATE_WALLET_BUSDT_BALANCE"] = "UPDATE_WALLET_BUSDT_BALANCE";
  ActionType["UPDATE_WALLET_THG_BALANCE"] = "UPDATE_WALLET_THG_BALANCE";
  ActionType["UPDATE_PROFILE_REQUESTED"] = "UPDATE_PROFILE_REQUESTED";
  ActionType["UPDATE_PROFILE_SUCCESS"] = "UPDATE_PROFILE_SUCCESS";
  ActionType["UPDATE_PROFILE_FAILURE"] = "UPDATE_PROFILE_FAILURE";
  ActionType["REFRESH_TOKEN_FAILED"] = "REFRESH_TOKEN_FAILED";
  ActionType["INVALIDATE_CONFIRM_CASHOUT"] = "INVALIDATE_CONFIRM_CASHOUT";
  ActionType["CONFIRM_CASHOUT_REQUESTED"] = "CONFIRM_CASHOUT_REQUESTED";
  ActionType["CONFIRM_CASHOUT_SUCCESS"] = "CONFIRM_CASHOUT_SUCCESS";
  ActionType["CONFIRM_CASHOUT_FAILURE"] = "CONFIRM_CASHOUT_FAILURE";
  ActionType["INVALIDATE_CASHOUT_LIMIT"] = "INVALIDATE_CASHOUT_LIMIT";
  ActionType["FETCH_CASHOUT_LIMIT_REQUESTED"] = "FETCH_CASHOUT_LIMIT_REQUESTED";
  ActionType["FETCH_CASHOUT_LIMIT_SUCCESS"] = "FETCH_CASHOUT_LIMIT_SUCCESS";
  ActionType["FETCH_CASHOUT_LIMIT_FAILURE"] = "FETCH_CASHOUT_LIMIT_FAILURE";
  ActionType["FETCH_CHECK_ACCOUNT_CASHOUT_REQUESTED"] = "FETCH_CHECK_ACCOUNT_CASHOUT_REQUESTED";
  ActionType["FETCH_CHECK_ACCOUNT_CASHOUT_SUCCESS"] = "FETCH_CHECK_ACCOUNT_CASHOUT_SUCCESS";
  ActionType["FETCH_CHECK_ACCOUNT_CASHOUT_FAILURE"] = "FETCH_CHECK_ACCOUNT_CASHOUT_FAILURE";
  ActionType["UPDATE_AVATAR_REQUESTED"] = "UPDATE_AVATAR_REQUESTED";
  ActionType["UPDATE_AVATAR_SUCCESS"] = "UPDATE_AVATAR_SUCCESS";
  ActionType["UPDATE_AVATAR_FAILURE"] = "UPDATE_AVATAR_FAILURE";
  ActionType["FETCH_AVATAR_CONFIG_REQUESTED"] = "FETCH_AVATAR_CONFIG_REQUESTED";
  ActionType["FETCH_AVATAR_CONFIG_SUCCESS"] = "FETCH_AVATAR_CONFIG_SUCCESS";
  ActionType["FETCH_AVATAR_CONFIG_FAILURE"] = "FETCH_AVATAR_CONFIG_FAILURE";
  ActionType["FETCH_AVATAR_ALLOWED_CONFIG_REQUESTED"] = "FETCH_AVATAR_ALLOWED_CONFIG_REQUESTED";
  ActionType["FETCH_AVATAR_ALLOWED_CONFIG_SUCCESS"] = "FETCH_AVATAR_ALLOWED_CONFIG_SUCCESS";
  ActionType["FETCH_AVATAR_ALLOWED_CONFIG_FAILURE"] = "FETCH_AVATAR_ALLOWED_CONFIG_FAILURE";
  ActionType["EXCHANGE_CURRENCY_REQUESTED"] = "EXCHANGE_CURRENCY_REQUESTED";
  ActionType["EXCHANGE_CURRENCY_SUCCESS"] = "EXCHANGE_CURRENCY_SUCCESS";
  ActionType["EXCHANGE_CURRENCY_FAILURE"] = "EXCHANGE_CURRENCY_FAILURE";
  ActionType["FETCH_INGAME_BALANCE_REQUESTED"] = "FETCH_INGAME_BALANCE_REQUESTED";
  ActionType["FETCH_INGAME_BALANCE_SUCCESS"] = "FETCH_INGAME_BALANCE_SUCCESS";
  ActionType["FETCH_INGAME_BALANCE_FAILURE"] = "FETCH_INGAME_BALANCE_FAILURE";
  ActionType["CLAIM_REFERRAL_REWARD_REQUESTED"] = "CLAIM_REFERRAL_REWARD_REQUESTED";
  ActionType["CLAIM_REFERRAL_REWARD_SUCCESS"] = "CLAIM_REFERRAL_REWARD_SUCCESS";
  ActionType["CLAIM_REFERRAL_REWARD_FAILURE"] = "CLAIM_REFERRAL_REWARD_FAILURE";
  ActionType["FETCH_SELECTED_COSMETIC_REQUESTED"] = "FETCH_SELECTED_COSMETIC_REQUESTED";
  ActionType["FETCH_SELECTED_COSMETIC_SUCCESS"] = "FETCH_SELECTED_COSMETIC_SUCCESS";
  ActionType["FETCH_SELECTED_COSMETIC_FAILURE"] = "FETCH_SELECTED_COSMETIC_FAILURE";
  ActionType["FETCH_COSMETIC_CONFIG_REQUESTED"] = "FETCH_COSMETIC_CONFIG_REQUESTED";
  ActionType["FETCH_COSMETIC_CONFIG_SUCCESS"] = "FETCH_COSMETIC_CONFIG_SUCCESS";
  ActionType["FETCH_COSMETIC_CONFIG_FAILURE"] = "FETCH_COSMETIC_CONFIG_FAILURE";
  ActionType["FETCH_SELECT_COSMETIC_REQUESTED"] = "FETCH_SELECT_COSMETIC_REQUESTED";
  ActionType["FETCH_SELECT_COSMETIC_SUCCESS"] = "FETCH_SELECT_COSMETIC_SUCCESS";
  ActionType["FETCH_SELECT_COSMETIC_FAILURE"] = "FETCH_SELECT_COSMETIC_FAILURE";
  ActionType["CLAIM_TOKEN_REQUESTED"] = "CLAIM_TOKEN_REQUESTED";
  ActionType["CLAIM_TOKEN_SUCCESS"] = "CLAIM_TOKEN_SUCCESS";
  ActionType["CLAIM_TOKEN_FAILURE"] = "CLAIM_TOKEN_FAILURE";
  ActionType["FETCH_REFERRAL_INFO_REQUESTED"] = "FETCH_REFERRAL_INFO_REQUESTED";
  ActionType["FETCH_REFERRAL_INFO_SUCCESS"] = "FETCH_REFERRAL_INFO_SUCCESS";
  ActionType["FETCH_REFERRAL_INFO_FAILURE"] = "FETCH_REFERRAL_INFO_FAILURE";
  ActionType["FETCH_COSMETIC_ALL_INVENTORY_REQUESTED"] = "FETCH_COSMETIC_ALL_INVENTORY_REQUESTED";
  ActionType["FETCH_COSMETIC_ALL_INVENTORY_SUCCESS"] = "FETCH_COSMETIC_ALL_INVENTORY_SUCCESS";
  ActionType["FETCH_COSMETIC_ALL_INVENTORY_FAILURE"] = "FETCH_COSMETIC_ALL_INVENTORY_FAILURE";
  ActionType["FETCH_THETAN_BOX_LIST_REQUESTED"] = "FETCH_THETAN_BOX_LIST_REQUESTED";
  ActionType["FETCH_THETAN_BOX_LIST_SUCCESS"] = "FETCH_THETAN_BOX_LIST_SUCCESS";
  ActionType["FETCH_THETAN_BOX_LIST_FAILURE"] = "FETCH_THETAN_BOX_LIST_FAILURE";
  ActionType["FETCH_BALANCE_HISTORY_REQUESTED"] = "FETCH_BALANCE_HISTORY_REQUESTED";
  ActionType["FETCH_BALANCE_HISTORY_SUCCESS"] = "FETCH_BALANCE_HISTORY_SUCCESS";
  ActionType["FETCH_BALANCE_HISTORY_FAILURE"] = "FETCH_BALANCE_HISTORY_FAILURE";
  ActionType["FETCH_TRANSACTION_HISTORY_REQUESTED"] = "FETCH_TRANSACTION_HISTORY_REQUESTED";
  ActionType["FETCH_TRANSACTION_HISTORY_SUCCESS"] = "FETCH_TRANSACTION_HISTORY_SUCCESS";
  ActionType["FETCH_TRANSACTION_HISTORY_FAILURE"] = "FETCH_TRANSACTION_HISTORY_FAILURE";
  ActionType["FETCH_COSMETIC_HISTORY_REQUESTED"] = "FETCH_COSMETIC_HISTORY_REQUESTED";
  ActionType["FETCH_COSMETIC_HISTORY_SUCCESS"] = "FETCH_COSMETIC_HISTORY_SUCCESS";
  ActionType["FETCH_COSMETIC_HISTORY_FAILURE"] = "FETCH_COSMETIC_HISTORY_FAILURE";
  ActionType["FETCH_HERO_HISTORY_REQUESTED"] = "FETCH_HERO_HISTORY_REQUESTED";
  ActionType["FETCH_HERO_HISTORY_SUCCESS"] = "FETCH_HERO_HISTORY_SUCCESS";
  ActionType["FETCH_HERO_HISTORY_FAILURE"] = "FETCH_HERO_HISTORY_FAILURE";
  ActionType["FETCH_RENTAL_HISTORY_REQUESTED"] = "FETCH_RENTAL_HISTORY_REQUESTED";
  ActionType["FETCH_RENTAL_HISTORY_SUCCESS"] = "FETCH_RENTAL_HISTORY_SUCCESS";
  ActionType["FETCH_RENTAL_HISTORY_FAILURE"] = "FETCH_RENTAL_HISTORY_FAILURE";
  ActionType["FETCH_VESTING_SAFE_HISTORY_REQUESTED"] = "FETCH_VESTING_SAFE_HISTORY_REQUESTED";
  ActionType["FETCH_VESTING_SAFE_HISTORY_SUCCESS"] = "FETCH_VESTING_SAFE_HISTORY_SUCCESS";
  ActionType["FETCH_VESTING_SAFE_HISTORY_FAILURE"] = "FETCH_VESTING_SAFE_HISTORY_FAILURE";
  ActionType["FETCH_BATTLE_REWARDS_REQUESTED"] = "FETCH_BATTLE_REWARDS_REQUESTED";
  ActionType["FETCH_BATTLE_REWARDS_SUCCESS"] = "FETCH_BATTLE_REWARDS_SUCCESS";
  ActionType["FETCH_BATTLE_REWARDS_FAILURE"] = "FETCH_BATTLE_REWARDS_FAILURE";
  ActionType["FETCH_COSMETIC_INVENTORY_REQUESTED"] = "FETCH_COSMETIC_INVENTORY_REQUESTED";
  ActionType["FETCH_COSMETIC_INVENTORY_SUCCESS"] = "FETCH_COSMETIC_INVENTORY_SUCCESS";
  ActionType["FETCH_COSMETIC_INVENTORY_FAILURE"] = "FETCH_COSMETIC_INVENTORY_FAILURE";
  ActionType["FETCH_INVENTORY_RESULT_REQUESTED"] = "FETCH_INVENTORY_RESULT_REQUESTED";
  ActionType["FETCH_INVENTORY_RESULT_SUCCESS"] = "FETCH_INVENTORY_RESULT_SUCCESS";
  ActionType["FETCH_INVENTORY_RESULT_FAILURE"] = "FETCH_INVENTORY_RESULT_FAILURE";
  ActionType["FETCH_REFERRAL_FLOATING_INFO_REQUESTED"] = "FETCH_REFERRAL_FLOATING_INFO_REQUESTED";
  ActionType["FETCH_REFERRAL_FLOATING_INFO_SUCCESS"] = "FETCH_REFERRAL_FLOATING_INFO_SUCCESS";
  ActionType["FETCH_REFERRAL_FLOATING_INFO_FAILURE"] = "FETCH_REFERRAL_FLOATING_INFO_FAILURE";
  ActionType["FETCH_GIFT_BOX_LIST_REQUESTED"] = "FETCH_GIFT_BOX_LIST_REQUESTED";
  ActionType["FETCH_GIFT_BOX_LIST_SUCCESS"] = "FETCH_GIFT_BOX_LIST_SUCCESS";
  ActionType["FETCH_GIFT_BOX_LIST_FAILURE"] = "FETCH_GIFT_BOX_LIST_FAILURE";
  ActionType["FETCH_BOX_HISTORY_REQUESTED"] = "FETCH_BOX_HISTORY_REQUESTED";
  ActionType["FETCH_BOX_HISTORY_SUCCESS"] = "FETCH_BOX_HISTORY_SUCCESS";
  ActionType["FETCH_BOX_HISTORY_FAILURE"] = "FETCH_BOX_HISTORY_FAILURE";
})(ActionType || (ActionType = {}));

export { AppError, EipError } from '@wolffun/shared/src/types';